<template>
  <div
    v-if="isSharePoster"
    @click.stop="cancel"
    :style="!htmlUrl ? 'opacity:0' : 'opacity:0'"
    class="small-share-content"
  >
    <div class="share-box">
      <div
        v-if="detail"
        :class="htmlUrl ? 'smallbg' : 'bg'"
        id="shareimg"
        ref="shareimg"
        @click.stop="tempAction"
      >
        <!-- <template v-if="htmlUrl">
          <img style="width:100%;height:100%;" :src="htmlUrl" />
        </template> -->
        <template>
          <div :style="{ width: 335 + 'px', minHeight: 623 + 'px' }" class="bgbox">
            <div style="width:100%;height:357px;" class="imgbox" id="left">
              <!-- <img
                :style="{
                  width: imageShowWidth + 'px',
                  height: imageShowHeight + 'px',
                }"
                class="smallCanvas"
                crossOrigin="anonymous"
                src=""
              />-->
            </div>
            <!-- <div style='margin:0 -20px;height: 150px;'>
                <img style="width:100%;height:100%;object-fit: contain;" :src="detail.imageUrl" />
            </div>-->
            <div class="infoshare">
              <div class="left">
                <div class="userShopInfos" v-if="shoplogoUrl">
                  <img class="shopLogo" :src="shoplogoUrl" alt="" />
                  <span>{{ shopName }}</span>
                </div>
                <div v-if="tagIcon">
                  <img :src="tagIcon" class="img" alt="" />
                </div>
                <div v-if="titleName" class="title">
                  <div
                    class="auc-tag"
                    v-if="aucState"
                    :style="{ backgroundColor: aucState.bgColor }"
                  >
                    {{ aucState.name }}
                  </div>
                  <div :class="aucState ? 'titlename' : ''">
                    {{
                      parseInt(titleName.length) > 29
                        ? titleName.substring(0, 29) + '...'
                        : titleName
                    }}
                  </div>
                </div>
                <div v-if="descText3" class="name">{{ descText3 }}</div>
                <div
                  v-if="price"
                  style="margin-top:20px;"
                  :class="this.posterType == 7 ? 'timebot' : ''"
                  class="time"
                >
                  {{ price.name }}
                  <span>{{ price.price }}</span>
                </div>
                <div v-if="descText1" :class="this.posterType != 6 ? 'timebot' : ''" class="time">
                  {{ descText1 }}
                </div>
                <div v-if="descText2" :class="this.posterType != 6 ? 'timebot' : ''" class="time">
                  {{ descText2 }}
                </div>
                <div v-if="descText4" :class="this.posterType != 6 ? 'timebot' : ''" class="time">
                  {{ descText4 }}
                </div>
              </div>
            </div>
            <div class="posterline"></div>
            <div class="posterbottom">
              <div class="left">
                <div>长按识别二维码</div>
                <div>打开小程序</div>
              </div>
              <div class="right" id="right">
                <!-- <img :src="wxQrImg" class="wxQrImg" crossOrigin="anonymous" /> -->
                <!-- <vue-qr
                  :text="qrOtion.url"
                  :logoSrc="shoplog"
                  :logoScale="0.4"
                  :correctLevel="3"
                  :size="200"
                ></vue-qr> -->
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="bottom">
        <div class="sava-btn">{{ htmlUrl ? '长按图片保存到手机' : '绘制中，请稍候' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDateTime, formatDateTimehhmm } from '@/utils/index';
import { getQrParam } from '@/utils/platHelper';
import { getQrcode } from '@/api/share';
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
import vueQr from 'vue-qr';
import { Toast, ImagePreview } from 'vant';
import Cookies from 'js-cookie';

import {
  getArtworkDesc,
  getArtworkPriceArrange,
  getPriceArrange,
  setMarginTypeData,
} from '@/utils/index.js';
export default {
  components: {
    'vue-qr': vueQr,
  },
  props: ['detail'],
  created() {},
  watch: {
    detail: {
      handler(value, oldVal) {
        console.log(value);
        if (value) {
          this.sharePoster();
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      isSharePoster: false,
      bgShowWidth: 0,
      bgShowHeight: 0,
      imageShowwidth: 0,
      imageShowHeight: 0,
      sacleXS: 2.0, // 生成的分享图放大倍数
      qrcodeimg: '',
      wxQrImg: '',
      posterType: -1,
      aucState: null,
      statusIndex: 0,
      aucEvaluation: '', //估价
      startTime: '',
      endTime: '',
      canvasHeight: 0,
      imageShowWidth: 0,
      htmlUrl: '',
      titleName: '', // 显示海报标题
      price: null, //价格
      descText1: '', // 详细描述文字1
      descText2: '', // 详细描述文字1
      descText3: '', // 详细描述文字1
      descText4: '', // 详细描述文字1
      aucStatus: [
        {
          name: '同步拍·预展中',
          bgColor: '#267762',
        },
        {
          name: '同步拍·拍卖中',
          bgColor: '#FF5757',
        },
        {
          name: '同步拍·已结束',
          bgColor: '#C5C5C5',
        },
        {
          name: '同步拍·待预展',
          bgColor: '#3b83f6',
        },

        {
          name: '限时拍·预展中',
          bgColor: '#267762',
        },
        {
          name: '限时拍·拍卖中',
          bgColor: '#FF5757',
        },
        {
          name: '限时拍·已结束',
          bgColor: '#C5C5C5',
        },
        {
          name: '限时拍·待预展',
          bgColor: '#3b83f6',
        },
        {
          name: '群组拍·预展中',
          bgColor: '#267762',
        },
        {
          name: '群组拍·拍卖中',
          bgColor: '#FF5757',
        },
        {
          name: '群组拍·已结束',
          bgColor: '#C5C5C5',
        },
        {
          name: '群组拍·待预展',
          bgColor: '#3b83f6',
        },
      ],
      qrOtion: {
        url: '',
      },
      tagIcons: {
        //直播状态iocn
        '0': 'https://img.zai-art.com/zaiart/saas/image/md/8a18959826ebeabc9a7cd15d3ac48a16.png',
        '1': 'https://img.zai-art.com/zaiart/saas/image/md/775c37e78d283ef256c52c96719d2d4d.png',
        '2': 'https://img.zai-art.com/zaiart/saas/image/md/775c37e78d283ef256c52c96719d2d4d.png',
        '3': 'https://img.zai-art.com/zaiart/saas/image/md/ac8a175fe79e2ec5c8422ed2d8c11842.png',
      },
      tagIcon: null,
      imageUrl: '',
      userShopInfos: null,
    };
  },
  computed: {
    shoplogoUrl() {
      let data = JSON.parse(Cookies.get('userShopinfos')).logoUrl;
      return data;
    },
    shopName() {
      let data = JSON.parse(Cookies.get('userShopinfos')).name;
      return data;
    },
  },
  created() {
    // this.userShopInfos = this.$store.state.app.userinfos || null
    // console.log(this.$store.state.app.userinfos)
  },
  methods: {
    getArtworkDesc,
    getArtworkPriceArrange,
    getPriceArrange,
    setMarginTypeData,
    sharePoster() {
      if ((this.$route.query && this.$route.query.id) || this.$route.params.id) {
        return;
      }
      if (this.detail) {
        Toast.loading({
          message: '生成中...',
          forbidClick: true,
        });

        const data = getQrParam(this.detail.dataType, this.detail.id);
        const _this = this;
        getQrcode(data).then(res => {
          _this.wxQrImg = res.data.url;
          _this.handleData();
        });
      }
    },
    getBase64Image(img, width, height) {
      var canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      var dataURL = canvas.toDataURL('image/png');
      return dataURL;
      // return dataURL.replace("data:image/png;base64,", "");
    },
    main(url, width, height, flag, ids) {
      let img = document.createElement('img');
      const _this = this;
      img.setAttribute('crossOrigin', 'Anonymous');
      console.log(url);
      img.src = url; //此处自己替换本地图片的地址
      img.onload = async function() {
        let data = await _this.getBase64Image(img, width, height);
        let img1 = document.createElement('img');
        img1.setAttribute('crossOrigin', 'Anonymous');
        if (!flag) {
          img1.setAttribute('class', 'smallCanvas');
          img1.setAttribute(
            'style',
            'width:' +
              _this.imageShowWidth +
              'px;height:' +
              _this.imageShowHeight +
              'px;object-fit: contain',
          );
          _this.imageUrl = data;
        } else {
          // img1.setAttribute("width",width + 'px')
          // img1.setAttribute("height",height+ 'px')
          img1.setAttribute('style', 'width:70px;height:70px;');
          _this.wxQrImg = data;
          console.log(data);
        }
        img1.src = data;
        ids.appendChild(img1);
      };
    },
    handleData() {
      if (this.detail.dataType == 31) {
        this.posterType = 1; // 商品
      } else if (this.detail.dataType == 9) {
        this.posterType = 2; // 活动
      } else if (this.detail.dataType == 2) {
        this.posterType = 3; // 展览
      } else if (this.detail.dataType == 3) {
        this.posterType = 4; // 作品
      } else if (this.detail.dataType == 10) {
        this.posterType = 5; // 文章
      } else if (this.detail.dataType == 45) {
        this.posterType = 6; // 拍卖专场
        this.computeAucStatus();
      } else if (this.detail.dataType == 46) {
        this.posterType = 7; // 拍品
        this.computeAucStatus();
      } else if (this.detail.dataType == 49) {
        this.posterType = 8; // 视频
      } else if (this.detail.dataType == 21) {
        this.posterType = 9; // 直播
      }
      this.handleMianImageInfo();
    },
    // 处理图片信息，设置显示分项图的宽高
    handleMianImageInfo() {
      let res = this.detail;
      let scale = 1.0;
      this.imageShowWidth = 335;
      this.imageShowHeight = 357;
      // this.imageShowHeight = parseInt(
      //   (res.imageHeight * this.imageShowWidth) / res.imageWidth
      // )
      this.sacleXS = 3.0; // 放大三倍

      // //限制竖图最大高度
      // if (this.imageShowHeight / this.imageShowWidth > 1.065) {
      //   this.imageShowHeight = 1.065 * this.imageShowWidth
      // }

      // //限制横图最低高度
      // if (this.imageShowHeight / this.imageShowWidth < 0.5) {
      //   this.imageShowHeight = 0.5 * this.imageShowWidth
      // }
      var realScale = res.imageHeight / res.imageWidth;
      if (res.imageHeight / res.imageWidth > 1) {
        this.imageShowWidth = parseInt(this.imageShowWidth / realScale);
      } else {
        this.imageShowHeight = parseInt(this.imageShowWidth * realScale);
      }
      if (this.imageShowHeight >= 357) {
        this.imageShowHeight = 357;
      }
      // 根据sacleXS 当大倍速，相应的改变底部高度
      let bottomScale = 2.0 / this.sacleXS;
      let qrcodeBottomHeight = 116 * scale * bottomScale;

      this.canvasHeight = qrcodeBottomHeight + this.imageShowHeight;

      this.bgShowWidth = this.imageShowWidth;
      this.bgShowHeight = parseInt(this.imageShowHeight + 4 + qrcodeBottomHeight + 58 * scale);

      this.drawShareImage();
    },

    drawShareImage() {
      console.log(this.detail);
      let scale = parseFloat(window.innerWidth / 375.0);
      // 根据sacleXS 当大倍速，相应的改变底部高度
      let bottomScale = 2.0 / this.sacleXS;

      // 计算图片绘制的x 和width
      let imageDrawX = 0;
      let imageDrawWidth = this.imageShowWidth;
      if (this.posterType === 1) {
        //商品
        this.titleName = this.detail.name ? this.detail.name : '';
        this.price = {
          name: '',
          price: getPriceArrange(this.detail) ? getPriceArrange(this.detail) : '',
        };
      }
      if (this.posterType === 2) {
        //活动
        this.titleName = this.detail.name ? this.detail.name : '';
        this.price = {
          name: '',
          price: getPriceArrange(this.detail.goodTo) ? getPriceArrange(this.detail.goodTo) : '免费',
        };
        this.descText1 = this.detail.startTime
          ? `时间：${formatDateTimehhmm(this.detail.startTime)}-${formatDateTimehhmm(
              this.detail.endTime,
            )}`
          : '';
        this.descText2 = this.detail.place ? `地点：${this.detail.place}` : '';
      }
      if (this.posterType == 3) {
        //展览
        this.titleName = this.detail.name ? this.detail.name : '';
        this.price = {
          name: '票价：',
          price: this.ticketPriceText(),
        };
        let startTime = formatDateTimehhmm(this.detail.exStartTime);
        let endTime = formatDateTimehhmm(this.detail.exEndTime);
        let exhibtionTime = startTime + (endTime ? `-${endTime}` : '');
        this.descText1 = `展览时间：${exhibtionTime}`; //展览时间
        this.descText2 = this.detail.openTime ? `开放时间：${this.detail.openTime}` : ''; //开放时间
        this.descText4 = this.detail.exPavilion ? `场馆：${this.detail.exPavilion}` : ''; //场馆
      }
      if (this.posterType === 4) {
        //作品
        this.titleName = this.detail.name ? this.detail.name : '';
        this.descText3 = getArtworkDesc(this.detail);
        this.price = {
          name: '',
          price: getArtworkPriceArrange(this.detail),
        };
      }
      if (this.posterType === 5) {
        //文章
        this.titleName = this.detail.title ? this.detail.title : '';
        this.descText3 = this.detail.author ? `作者：${this.detail.author}` : '';
      }
      if (this.posterType === 6) {
        //拍卖专场

        let addBottomHeight = -20; // 底部需要增加的高度
        this.titleName = this.detail.name ? this.detail.name : '';
        let startTime = '';
        if (this.detail.type == 1 && this.detail.aucEndTime && this.detail.status == 1) {
          startTime = '结拍时间：' + ' ' + formatDateTimehhmm(this.detail.aucEndTime);
        } else if (
          (this.detail.status == 0 && this.detail.aucStartTime) ||
          (this.detail.type == 1 && this.detail.aucStartTime && this.detail.status != 2)
        ) {
          startTime = '开拍时间' + '：' + formatDateTimehhmm(this.detail.aucStartTime);
        } else if (this.detail.type == 0 && this.detail.liveStartTime) {
          // 同步拍用liveStartTime
          startTime = '开拍时间' + '：' + formatDateTimehhmm(this.detail.liveStartTime);
        }
        this.descText1 = startTime;

        let endTime = '';
        if (this.detail.status == 2) {
          if (this.detail.liveEndTime) {
            endTime = '结拍时间' + '：' + formatDateTimehhmm(this.detail.liveEndTime);
          } else if (this.detail.aucEndTime) {
            endTime = '结拍时间' + '：' + formatDateTimehhmm(this.detail.aucEndTime);
          }
        }
        this.descText2 = endTime;

        let artworkstr = '';
        if (this.detail.artworkPublicCount) {
          artworkstr = `${this.detail.artworkPublicCount}件拍品  /  ${setMarginTypeData(
            this.detail,
          )}`;
        }
        // if (
        //   this.detail.specialMarginAmount ||
        //   this.detail.specialMarginAmount == 0
        // ) {
        //   artworkstr = `${this.detail.artworkPublicCount}件拍品 / 免专场保证金`

        //   if (this.detail.specialMarginAmount > 0) {
        //     artworkstr = `${this.detail.artworkPublicCount}件拍品 / 专场保证金 ${this.detail.mainCurrency.mark}${this.detail.specialMarginAmount}`
        //   }
        // }
        this.descText3 = artworkstr;

        // 拍卖状态
        this.aucState = this.aucStatus[this.statusIndex];
      } else if (this.posterType === 7) {
        //拍品
        let addBottomHeight = -20; // 底部需要增加的高度

        // 标题
        let lotStr = this.detail.lot ? `LOT ${this.detail.lot}  ` : '';
        this.titleName = this.detail.name ? lotStr + this.detail.name : lotStr;

        // descText1  当前价
        this.price = {
          name:
            this.detail.status == 2 && this.detail.dealStatus == 2
              ? '落槌价：'
              : this.detail.status == 0
              ? '起拍价：'
              : '当前价：',
          price: this.detail.currentPrice
            ? `${this.detail.mainCurrency.mark}${this.detail.currentPrice.price}`
            : `${this.detail.mainCurrency.mark}0`,
        };
        if (this.detail.status == 0) {
          this.price.price = `${this.detail.mainCurrency.mark} ${this.detail.startingPrice}`;
        } else if (this.detail.status == 2) {
          if (this.detail.dealStatus == 2) {
            this.price.price = `${this.detail.mainCurrency.mark} ${this.detail.dealPrice}`;
          } else if (this.detail.dealStatus == 4) {
            this.price.name = '';
            this.price.price = '撤拍';
          } else if (this.detail.dealStatus == 3) {
            this.price.name = '';
            this.price.price = '未成交';
          } else if (!this.detail.dealStatus) {
            this.price.name = '';
            this.price.price = '结算中';
          }
        }
        this.currentPrice = this.detail.currentPrice
          ? `当前价：${this.detail.mainCurrency.mark}${this.detail.currentPrice.price}`
          : `当前价：${this.detail.mainCurrency.mark}0`;

        // descText3   规格
        this.descText3 = this.getDescriptionOfDetails();

        // descText2  //开拍时间
        let startTime = '';
        if (this.detail.type == 1 && this.detail.aucEndTime && this.detail.status == 1) {
          startTime = '结拍时间：' + ' ' + formatDateTimehhmm(this.detail.aucEndTime);
        } else if (
          (this.detail.status == 0 && this.detail.aucStartTime) ||
          (this.detail.type == 1 && this.detail.aucStartTime)
        ) {
          startTime = '开拍时间' + '：' + formatDateTimehhmm(this.detail.aucStartTime);
          addBottomHeight += 10;
        } else if (this.detail.type == 0 && this.detail.liveStartTime) {
          // 同步拍用liveStartTime
          startTime = '开拍时间' + '：' + formatDateTimehhmm(this.detail.liveStartTime);
          addBottomHeight += 10;
        }
        this.descText2 = startTime;

        // descText4
        let endTime = '';
        if (this.detail.status == 2) {
          if (this.detail.liveEndTime) {
            endTime = '结束时间' + '：' + formatDateTimehhmm(this.detail.liveEndTime);
            addBottomHeight += 10;
          } else if (this.detail.aucEndTime) {
            endTime = '结束时间' + '：' + formatDateTimehhmm(this.detail.aucEndTime);
            addBottomHeight += 10;
          }
        }
        this.descText4 = endTime;

        // 拍卖状态
        this.aucState = this.aucStatus[this.statusIndex];
      }
      if (this.posterType === 8) {
        //视频
        this.titleName = this.detail.name ? this.detail.name : '';
      } else if (this.posterType === 9) {
        this.titleName = this.detail.title ? this.detail.title : '';
        this.tagIcon = this.tagIcons[this.detail.roomStatus];
        let startTime = '';
        let endTime = '';
        startTime = '开始时间' + '：' + formatDateTimehhmm(this.detail.liveTime);
        this.descText2 = startTime;
        this.descText4 = endTime;
      }

      this.isSharePoster = true;
      let that = this;
      let flag1 = false;
      let flag2 = false;
      const setCanvas = setInterval(function() {
        if (!flag1 && document.getElementById('right')) {
          that.main(that.wxQrImg, '200', '200', true, document.getElementById('right'));
          flag1 = true;
        } else if (!flag2 && document.getElementById('left')) {
          that.main(
            that.detail.imageUrl,
            that.imageShowWidth,
            that.imageShowHeight,
            false,
            document.getElementById('left'),
          );
          flag2 = true;
        } else if (
          that.imageUrl.indexOf('data:image/png;base64') != -1 &&
          that.wxQrImg.indexOf('data:image/png;base64') != -1
        ) {
          clearInterval(setCanvas);
          that.drawimg();
        }
      }, 100);
    },
    // 下载拍卖状态图片
    computeAucStatus() {
      let statusIndex = 0;
      if (this.posterType == 6) {
        if (this.detail.status == 5) {
          this.detail.status = this.detail.status - 2;
        }
        if (this.detail.type == 0) {
          statusIndex = this.detail.status;
        } else if (this.detail.type == 1) {
          statusIndex = this.detail.status + 4;
        } else if (this.detail.type == 2) {
          statusIndex = this.detail.status + 7;
        }
      } else {
        if (this.detail.status == 5) {
          this.detail.status = this.detail.status - 2;
        }
        if (this.detail.type == 0) {
          statusIndex = this.detail.status;
        } else if (this.detail.type == 1) {
          statusIndex = this.detail.status + 4;
        } else if (this.detail.type == 2) {
          statusIndex = this.detail.status + 7;
        }
      }
      this.statusIndex = statusIndex;
    },
    cancel() {
      this.isSharePoster = false;
      this.htmlUrl = '';
      this.imageUrl = '';
      this.wxQrImg = '';
      this.$emit('clear');
    },
    tempAction() {},
    drawimg() {
      let that = this;
      html2canvas(document.querySelector('#shareimg'), {
        backgroundColor: null,
        useCORS: true, //支持图片跨域
        scale: 3, //设置放大的倍数
        allowTaint: false,
        // logging: false,
        proxy: that.qrcodeimg,
        logging: true,
        // windowHeight:document.body.scrollHeight
      }).then(canvas => {
        let url = canvas.toDataURL('image/png');
        that.htmlUrl = url; // 把生成的base64位图片上传到服务器,生成在线图片地址
        Toast.clear();
        ImagePreview({
          images: [that.htmlUrl],
          closeable: true,
          showIndex: false,
          className: 'ImagePreview',
        });
        this.cancel();
        // this.sendUrl()
      });
    },
    getDescriptionOfDetails() {
      let detail = this.detail;
      var res = '';
      var start = 0;
      if (detail.author && detail.author.length) {
        start = 1;
        res += detail.author;
      }
      if (detail.year && detail.year.length) {
        res += start == 1 ? ' / ' : '';
        res += detail.year;
        start = 1;
      }
      if (detail.size && detail.size.length) {
        res += start == 1 ? ' / ' : '';
        res += detail.size;
        start = 1;
      }
      if (detail.material && detail.material.length) {
        res += start == 1 ? ' / ' : '';
        res += detail.material;
        start = 1;
      }
      if (detail.padescription && detail.padescription.length) {
        res += start == 1 ? ' / ' : '';
        res += detail.padescription;
      }
      if (detail.process && detail.process.length) {
        res += start == 1 ? ' / ' : '';
        res += detail.process;
      }
      if (res.length > 3 && res.charAt(res.length - 3) == ' / ') {
        res = res.substring(0, res.length - 3);
      }
      return res;
    },
    ticketPriceText() {
      function sortNum(a, b) {
        return a - b;
      }
      if (this.detail.goodTo && this.detail.goodTo.goodStockList) {
        let priceLow = '';
        let priceHigh = '';
        let prices = this.detail.goodTo.goodStockList.map(good => {
          return good.sellPrice;
        });
        if (prices.length == 1) {
          priceLow = prices[0];
        } else if (prices.length > 1) {
          prices.sort(sortNum);
          priceLow = prices[0];
          priceHigh = prices[prices.length - 1];
        }
        return this.ticketPriceComputed(priceLow, priceHigh);
      } else {
        return '免费';
      }
    },
    ticketPriceComputed(priceLow, priceHigh) {
      if (priceLow && priceHigh) {
        if (priceLow == priceHigh) {
          return '¥ ' + priceHigh;
        }
        return '¥ ' + priceLow + '-' + priceHigh;
      } else {
        if (priceLow) {
          return '¥ ' + priceLow;
        } else if (priceHigh) {
          return '¥ ' + priceHigh;
        } else if (priceLow === priceHigh && priceLow === 0) {
          return '免费';
        } else {
          return '免费';
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.small-share-content {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  .share-box {
    // width: 208px;
    border-radius: 8px;
    position: relative;
    background-color: white;
    overflow: hidden;
    // padding: 0 25px 0px 25px;
    box-sizing: border-box;
    z-index: 100;
    .bg {
      width: 375px;
      background: #f4f4f4;
      position: relative;
      z-index: 110;
      padding: 24px 20px 20px 20px;
      box-sizing: border-box;
      .smallCanvas {
        display: block;
        z-index: 120;
        margin: 0 auto;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .auc-tag {
        display: inline-block;
        width: 86px;
        height: 20px;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        color: white;
        border-radius: 3px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        margin-right: 8px;
        position: absolute;
      }
      .titlename {
        text-indent: 95px;
        // display: -webkit-box;
        // -webkit-line-clamp: 2;
        // -webkit-box-orient: vertical;
        // overflow: hidden;
      }
    }
    .smallbg {
      width: 187.5px;
      background: #f4f4f4;
      position: relative;
      z-index: 110;
      box-sizing: border-box;
    }
    .bgbox {
      // padding: 0 25px 0px 25px;
      box-sizing: initial;
      background: #fff;
      border-radius: 4px;
    }
    .imgbox {
      width: 100%;
      height: 357px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .posterline {
      // width: 100%;
      margin: 0 16px;
      height: 1px;
      border-bottom: 1px solid #e5e5e5;
    }
    .infoshare {
      min-height: 222px;
      display: flex;
      padding: 24px 16px;
      position: relative;
      box-sizing: border-box;
      // margin: 0 -10px;
      .left {
        .title {
          // display: flex;
          // align-items: flex-start;
          font-size: 16px;
          font-weight: 600;
          color: rgba(0, 0, 0, 1);
          line-height: 22px;
          // padding-right: 55px;
          margin-bottom: 8px;
          position: relative;
        }
        .name {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(34, 34, 34, 1);
          line-height: 13px;
          margin-bottom: 4px;
          white-space: pre-wrap;
          margin-bottom: 20px;
        }
        .time {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 16px;
          margin-bottom: 5px;
          span {
            font-size: 24px;
            font-family: SFCompactText-Bold, SFCompactText;
            font-weight: bold;
            color: rgba(255, 62, 62, 1);
            line-height: 24px;
          }
          &:last-child {
            margin-bottom: 44px;
          }
        }
        .timebot {
          &:last-child {
            margin-bottom: 14px;
          }
        }
        .img {
          // position: absolute;
          width: 46px;
          height: 16px;
          // line-height: 16px;
          // top: 3px;
          // left: 0;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          color: #fff;
          font-size: 10px;
          text-align: right;
          overflow: hidden;
          border-radius: 1px;
        }
      }
      .right {
        position: absolute;
        right: 6px;
        top: 12px;
        img {
          display: block;
          width: 60px;
          height: 60px;
        }
      }
    }
    .posterbottom {
      padding: 24px 16px;
      position: relative;
      box-sizing: border-box;
      height: auto;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 18px;
      .left {
        padding-top: 12px;
      }
      .right {
        position: absolute;
        right: 16px;
        top: 12px;
        img {
          display: block;
          width: 60px;
          height: 60px;
          -webkit-touch-callout: none;
        }
      }
    }
    .bottom {
      height: 38px;
      width: 100%;
      bottom: 0;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
  }
}
.userShopInfos {
  padding-bottom: 20px;
}
.userShopInfos span {
  font-size: 14px;
  color: #333;
  margin-left: 10px;
}
.shopLogo {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}
</style>
